import { useParams, Link, Navigate } from "react-router-dom";
import { Swords } from "lucide-react";
import { getCollateral } from "../../lib/collateral";
import { COMPANY, IMAGES } from "../../lib/data";
import { CollateralBar, TierIcon } from "../../components/site/CollateralKit";

export default function ProductBattlecard() {
  const { product } = useParams();
  const c = getCollateral(product);
  if (!c) return <Navigate to="/solutions" replace />;
  const bc = c.battlecard;
  const pdf = `/${c.slug}-battlecard.pdf`;

  return (
    <div className="min-h-screen bg-charcoal/20 print:bg-white">
      <CollateralBar product={c.slug} label="Competitive Battlecard · One-Page" pdf={pdf} testid="battlecard" />
      <div className="py-8 print:py-0 flex justify-center">
        <div data-testid="collateral-sheet" className="bg-white shadow-2xl print:shadow-none w-[297mm] h-[210mm] p-[11mm] flex flex-col" style={{ fontSize: "10px" }}>
          <header className="flex items-start justify-between border-b-2 border-ink pb-3">
            <div>
              <div className="flex items-center gap-2 mb-1.5">
                <img src={IMAGES.markDark} alt="OneHarvest" className="h-6 w-6 object-contain" />
                <span className="font-display font-extrabold tracking-tight text-ink text-sm">ONEHARVEST</span>
                <span className="ml-2 border border-flame/40 bg-flame/10 text-flame px-2 py-0.5 text-[8px] uppercase tracking-[0.18em]">{c.name} · Competitive Battlecard</span>
              </div>
              <h1 className="font-display font-black tracking-tight text-ink leading-[1] text-[32px]">{bc.headline}</h1>
              <p className="mt-2 text-charcoal text-[11px]">A head-to-head on what actually drives <span className="font-semibold text-ink">total cost per job</span>.</p>
            </div>
            <Swords className="h-8 w-8 text-flame" />
          </header>

          <div className="flex-1 pt-4 flex flex-col min-h-0">
            <div className="grid grid-cols-[1.3fr_1.1fr_1fr_1fr] bg-ink text-white text-[9px] uppercase tracking-wider">
              <div className="px-3 py-2">Attribute</div>
              {bc.cols.map((col, i) => (<div key={col} className={`px-3 py-2 border-l border-white/10 font-display font-bold ${i === 0 ? "text-flame" : ""}`}>{col}</div>))}
            </div>
            <div className="flex-1 grid" style={{ gridTemplateRows: `repeat(${bc.rows.length}, 1fr)` }}>
              {bc.rows.map(([attr, vals, tiers], ri) => (
                <div key={attr} className={`grid grid-cols-[1.3fr_1.1fr_1fr_1fr] items-center border-b border-border ${ri % 2 ? "bg-muted/40" : "bg-white"}`}>
                  <div className="px-3 py-1.5 font-medium text-ink text-[10.5px]">{attr}</div>
                  {vals.map((val, ci) => (
                    <div key={ci} className={`px-3 py-1.5 border-l border-border flex items-center gap-1.5 text-[10px] ${ci === 0 ? "bg-flame/5" : ""}`}>
                      <TierIcon tier={tiers[ci]} />
                      <span className={ci === 0 ? "text-ink font-semibold" : "text-charcoal"}>{val}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="mt-3 bg-ink text-white px-5 py-3 flex items-center justify-between gap-4">
            <div><div className="font-display font-extrabold text-[15px]">Same job. Less material, less hauling, lower total cost.</div><div className="text-white/60 text-[10px] mt-0.5">{COMPANY.phone} · {COMPANY.email}</div></div>
            <Link to={`/collateral/${c.slug}/roi`} className="inline-flex items-center bg-flame text-white px-5 py-2.5 font-semibold text-[11px] hover:bg-flame/90 transition-colors print:hidden flex-shrink-0">See the ROI Brief</Link>
          </div>
          <p className="mt-2 text-[8px] text-muted-foreground text-center">Comparative positioning is representative of typical field performance; validate against your conditions. © {new Date().getFullYear()} {COMPANY.legal}.</p>
        </div>
      </div>
    </div>
  );
}
